export function diferenciaMinutos(dt1, dt2) {
    var dif = (dt2.getTime() - dt1.getTime()) / 1000;
    dif /= 60;
    return Math.abs(Math.round(dif));
}

export function getTime(date) {
    if (date != null) {
        // tomamos como fecha por defecto 1970-01-01T00:00:00.000Z para el caso de nulos
        return new Date("1970-01-01T" + date + ".000Z");
    }
    else
        return new Date(Date.UTC(1970, 1, 1, 0, 0, 0, 0));
}

export function fechaANro(fecha) {
    var resultado = 0;
    if (fecha !== null) {
        var fech = new Date(fecha);
        resultado = fech.getFullYear() * 10000 + fech.getMonth() * 100 + fech.getDate();
    } else {
        resultado = 0;
    }

    return resultado;
}

export function fechaGenerica(fecha) {
    if (fecha !== null) {
        return `${fecha.getFullYear()}${(fecha.getMonth() + 1).toString().padStart(2, '0')}${fecha
            .getDate()
            .toString()
            .padStart(2, '0')}`;
    }
    return null;
}
/**
 * Concatena una fecha y la hora en un solo obejto 
 * @param {*} date_ fecha la cual se pasa como parametro
 * @param {*} time_ Tiempo que se concatenara con la fecha
 * @returns Devuelve un objeto DATE con con la fecha y la hora concatenada
 */
export async function concatDateTime(date_, time_) {
    let date = new Date(date_);
    let time = new Date(time_);
    if (date === null || date === undefined) {
        if (time === null || time === undefined) {
            return null;
        } else {
            const hoy = new Date();
            return new Date(
                hoy.getFullYear(),
                hoy.getMonth(),
                hoy.getDate(),
                time.getHours(),
                time.getMinutes(),
                time.getSeconds(),
                time.getMilliseconds()
            );
        }
    } else {
        if (time === null || time === undefined) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
        } else {
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                time.getHours(),
                time.getMinutes(),
                time.getSeconds(),
                time.getMilliseconds()
            );
        }
    }
}
